import { SleekButton } from '../../../modules/theme';

export interface EmptyStateProps {
  title: string;
  description?: string;
  cta?: string;
  onAction?: () => void;
}

/**
 * Empty-state block for the Vault tabs (Cards / Shipping): text and an
 * optional pill CTA, no illustration (partner Figma 2026-10-14).
 * Themed via Design Constructor (`--co-MyPacksEmptyState-*`); the CTA is
 * its own `VaultEmptyStateButton`.
 */
export function EmptyState({ title, description, cta, onAction }: EmptyStateProps) {
  return (
    <div
      data-co-component="MyPacksEmptyState"
      className="flex flex-col items-center justify-center gap-6 px-6 py-16 text-center"
    >
      <div className="flex flex-col items-center gap-1">
        <h3
          className="font-semibold leading-[24px] tracking-[-0.43px]"
          style={{
            color: 'var(--co-MyPacksEmptyState-titleColor, #F4F4F5)',
            fontSize: 'var(--co-MyPacksEmptyState-titleSize, 17px)',
          }}
        >
          {title}
        </h3>

        {description && (
          <p
            className="max-w-[362px] text-[15px] leading-[24px] tracking-[-0.23px]"
            style={{ color: 'var(--co-MyPacksEmptyState-descriptionColor, #6D717E)' }}
          >
            {description}
          </p>
        )}
      </div>

      {cta && onAction && (
        <SleekButton name="VaultEmptyStateButton" onClick={onAction}>
          {cta}
        </SleekButton>
      )}
    </div>
  );
}
